import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  margin: ${props =>
    props.theme.marginDefault ? props.theme.marginDefault : '0 0 55px 0'};

  ${Media.md`
    margin: ${props =>
      props.theme.marginMd ? props.theme.marginMd : '0 0 25px 0'}; 
  `}

  &:empty {
    display: none;
  }
`;

export const Title = styled.h2`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: ${props =>
    `repeat(${props.theme.gridTemplateColumns || 4}, 1fr)`};
  grid-gap: ${props => `${props.theme.gridGap || 4}px`};

  ${Media.md`
    grid-template-columns: ${props =>
      `repeat(${props.theme.gridTemplateColumnsMd || 3}, 1fr)`};
  `}

  ${Media.sm`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const Item = styled.div`
  display: block;
  width: 100%;
`;

export const Link = styled.a`
  display: block;
  width: 100%;
`;

export const Imagebox = styled.picture`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const Source = styled.source``;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;
